import { Icon, Tooltip } from '@blueprintjs/core';

export const CallIcon = () => <Icon icon="phone" color="#15B371" />;
export const CommentIcon = () => <Icon icon="chat" color="#2B95D6" />;
export const SMSIcon = ({ inbound }: { inbound: boolean }) => (
  <Icon icon="comment" color={inbound ? '#A854A8' : '#4580e6'} />
);
export const OrttoSMSIcon = () => <Icon icon="comment" color="#1d7324" />;
export const FailIcon = () => <Icon icon="error" intent="danger" />;
export const EmailIcon = () => <Icon icon="envelope" color="#EB532D" />;
export const OrttoEmailIcon = () => <Icon icon="envelope" color="#1d7324" />;
export const TransactionalIcon = () => (
  <Tooltip content={'Transactional SMS'} position={'top'}>
    <Icon icon="exchange" color="#F5A623" />
  </Tooltip>
);
